export default "__VITE_ASSET__BJMmi7AB__"